const headerWrapper = document.querySelector(".header-wrapper");
const items = document.querySelector(".header__inline-menu").querySelectorAll("details");

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    items.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });
    item.setAttribute("open", true);
  });
});

document.addEventListener("mouseover", (event) => {
  if (!headerWrapper.contains(event.target) &&
      !event.target.closest('.mega-menu__content')) {
    items.forEach(item => {
      item.removeAttribute("open");
    });
  }
});